exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.close_margin[data-v-71c37c1e] {\n  margin-bottom: 10px;\n}\n.positif_amount[data-v-71c37c1e] {\n  color: green;\n}\n.negatif_amount[data-v-71c37c1e] {\n  color: red;\n}\n\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-71c37c1e","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/requests/TransactionsList.vue
// module id = 1579
// module chunks = 2